import React, { useState } from "react";
import { FiAlertTriangle, FiAlertCircle, FiInfo, FiCheckCircle } from "react-icons/fi";
import { severityColor, SeverityBadge } from "./irrigationHelpers";

const TYPE_ICONS = {
  Valve: "🔧", Pressure: "📊", Battery: "🔋", Signal: "📡", Moisture: "💧", Cycle: "✅", Schedule: "📅", Node: "📻",
};

const IrrAlertsPanel = ({ d }) => {
  const [filterSev, setFilterSev] = useState("All");
  const [filterStatus, setFilterStatus] = useState("Open");
  const [selected, setSelected] = useState(null);

  const filtered = d.alerts.filter(a => {
    const sevOk = filterSev === "All" || a.severity === filterSev;
    const statOk = filterStatus === "All" || a.status === filterStatus;
    return sevOk && statOk;
  });

  const critical  = d.alerts.filter(a => a.severity === "Critical").length;
  const warning   = d.alerts.filter(a => a.severity === "Warning").length;
  const info      = d.alerts.filter(a => a.severity === "Info").length;
  const openCount = d.alerts.filter(a => a.status === "Open").length;

  const sel = selected ? d.alerts.find(a => a.id === selected) : null;

  return (
    <div className="irr-alerts-panel">

      {/* Summary row */}
      <div className="irr-alert-summary">
        {[
          { label: "Critical", count: critical, color: "#ef4444", bg: "#fee2e2", icon: FiAlertTriangle },
          { label: "Warning",  count: warning,  color: "#f59e0b", bg: "#fef3c7", icon: FiAlertCircle  },
          { label: "Info",     count: info,     color: "#3b82f6", bg: "#dbeafe", icon: FiInfo         },
          { label: "Open",     count: openCount,color: "#667eea", bg: "#ede9fe", icon: FiAlertTriangle },
        ].map(s => (
          <div key={s.label} className="irr-alert-sum-card" style={{ borderTopColor: s.color, background: s.bg }}>
            <s.icon size={18} color={s.color} />
            <div className="irr-alert-sum-num" style={{ color: s.color }}>{s.count}</div>
            <div className="irr-alert-sum-lbl">{s.label}</div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div className="irr-map-filter">
        {["All","Critical","Warning","Info"].map(f => (
          <button key={f} className={`irr-filter-chip ${filterSev === f ? "irr-filter-active" : ""}`} onClick={() => setFilterSev(f)}>{f}</button>
        ))}
        <span style={{ margin: "0 8px", color: "#d1d5db" }}>|</span>
        {["All","Open","Closed"].map(f => (
          <button key={f} className={`irr-filter-chip ${filterStatus === f ? "irr-filter-active" : ""}`} onClick={() => setFilterStatus(f)}>{f}</button>
        ))}
      </div>

      <div className="irr-alerts-body">
        {/* Alert list */}
        <div className="irr-alert-list">
          {filtered.length === 0 && <div className="irr-empty">No alerts match current filter.</div>}
          {filtered.map(a => {
            const sc = severityColor(a.severity);
            return (
              <div key={a.id} className={`irr-alert-card ${a.id === selected ? "irr-alert-card-sel" : ""}`}
                style={{ borderLeftColor: sc.color }} onClick={() => setSelected(a.id === selected ? null : a.id)}>
                <div className="irr-ac-top">
                  <span className="irr-ac-type">{TYPE_ICONS[a.type] || "⚡"} {a.type}</span>
                  <SeverityBadge severity={a.severity} />
                  <span className="irr-ac-status" style={{
                    background: a.status === "Open" ? "#fee2e2" : "#d1fae5",
                    color: a.status === "Open" ? "#ef4444" : "#10b981",
                  }}>{a.status}</span>
                </div>
                <div className="irr-ac-msg">{a.message}</div>
                <div className="irr-ac-meta">
                  <span>Zone: {a.zone}</span>
                  <span>Node: {a.node}</span>
                  <span>🕐 {a.time}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Detail panel */}
        {sel && (
          <div className="irr-alert-detail">
            <div className="irr-ad-title">Alert Detail</div>
            <div className="irr-ad-id">{sel.id}</div>
            <SeverityBadge severity={sel.severity} />
            <div className="irr-ad-msg">{sel.message}</div>
            <div className="irr-ad-grid">
              <div><label>Zone</label><span>{sel.zone}</span></div>
              <div><label>Node</label><span>{sel.node}</span></div>
              <div><label>Time</label><span>{sel.time}</span></div>
              <div><label>Type</label><span>{sel.type}</span></div>
              <div><label>Status</label><span>{sel.status}</span></div>
            </div>
            {sel.status === "Open" && (
              <div className="irr-ad-actions">
                <button className="irr-ctrl-btn irr-ctrl-green">✓ Mark Resolved</button>
                <button className="irr-ctrl-btn irr-ctrl-blue">→ Assign</button>
              </div>
            )}
            {sel.severity === "Critical" && (
              <div className="irr-ad-ai">
                🤖 AI: {sel.type === "Valve" ? "Valve stuck likely due to debris or actuator failure. Check solenoid coil resistance." : sel.type === "Pressure" ? "Low pressure may indicate pipe burst or major leak. Isolate zone immediately." : "Investigate immediately."}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default IrrAlertsPanel;
